module.exports = __webpack_public_path__ + "img/airplane-dark.d699b68b.jpg";